import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StaffAuthService } from '../staff/staff-auth.service';
import { StaffAccountsService } from '../staff/api-services/staff-accounts.service';
import { IStaffAccountDto } from '../interfaces/dtos/staff/IStaffAccountDto';

export const getCurrentStaffAccountResolver: ResolveFn<IStaffAccountDto | null> = async () => {
  return await new Promise<IStaffAccountDto | null>(resolve => {
    const staffAuthService = inject(StaffAuthService);
    const staffAccountsService = inject(StaffAccountsService);

    const clientLoginToken = staffAuthService.GetAuthToken();
    if (clientLoginToken !== null){
      staffAccountsService.GetCurrentAccount().subscribe({
        next: apiResponse => {
          return resolve(apiResponse.Data!);
        },
        error: () => {
          return resolve(null);
        }
      });
    } else {
      return resolve(null);
    }
  });
};
